function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_BOOKMARK_REQUEST = "POST_BOOKMARK_REQUEST";
export var POST_BOOKMARK_SUCCESS = "POST_BOOKMARK_SUCCESS";
export var POST_BOOKMARK_FAILURE = "POST_BOOKMARK_FAILURE";
export var RESET_POST_BOOKMARK = "RESET_POST_BOOKMARK";
export var postBookmark = function postBookmark(bookmark) {
  return _defineProperty({
    bookmark: bookmark
  }, CALL_API, {
    types: [POST_BOOKMARK_REQUEST, POST_BOOKMARK_SUCCESS, POST_BOOKMARK_FAILURE],
    endpoint: "bookmarks",
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bookmark),
      credentials: "same-origin"
    }
  });
};
export var resetPostBookmark = function resetPostBookmark() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_BOOKMARK
    });
  };
};
export var DELETE_BOOKMARK_REQUEST = "DELETE_BOOKMARK_REQUEST";
export var DELETE_BOOKMARK_SUCCESS = "DELETE_BOOKMARK_SUCCESS";
export var DELETE_BOOKMARK_FAILURE = "DELETE_BOOKMARK_FAILURE";
export var RESET_DELETE_BOOKMARK = "RESET_DELETE_BOOKMARK";
export var deleteBookmark = function deleteBookmark(bookmark) {
  return _defineProperty({
    bookmark: bookmark
  }, CALL_API, {
    types: [DELETE_BOOKMARK_REQUEST, DELETE_BOOKMARK_SUCCESS, DELETE_BOOKMARK_FAILURE],
    endpoint: "bookmarks/".concat(bookmark.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};
export var resetDeleteBookmark = function resetDeleteBookmark() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_DELETE_BOOKMARK
    });
  };
};